require('./angular');
module.exports = angular;



// WEBPACK FOOTER //
// ./src/libs/angular/index.js